import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Hook to check if current user is a SuperAdmin
 * and provide SuperAdmin-related functions
 */
export function useSuperAdmin() {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkSuperAdminAccess();
  }, []);

  const checkSuperAdminAccess = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/saas-admin/check-access`, {
        withCredentials: true
      });
      setIsSuperAdmin(response.data.is_super_admin);
    } catch (error) {
      console.error('Error checking SuperAdmin access:', error);
      setIsSuperAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  return {
    isSuperAdmin,
    loading,
    checkSuperAdminAccess
  };
}
